<template>
  <div class="top-bar">
    <div class="top-icons d-flex" v-if="isMobile">
      <k-hamburger-icon class="ml-auto"></k-hamburger-icon>
    </div>
    <div
      v-if="aktualisProjekt && aktualisProjekt.HeaderFl"
      class="page-content"
      :class="!isMobile ? 'd-flex justify-space-between' : 'd-block'"
    >
      <div class="title-wrapper">
        <div>
          <h1 v-if="aktualisProjekt && aktualisProjekt.MagazinCim">
            <router-link
              v-html="aktualisProjekt.MagazinCim"
              :to="{ name: 'Fooldal' }"
            ></router-link>
          </h1>
          <h1 v-else>StreamNext</h1>
        </div>
      </div>
      <div v-if="!isMobile">
        <k-desktop-top-menu></k-desktop-top-menu>
      </div>
    </div>
    <div
      class="page-content"
      v-else
      :style="{ height: this.placeholderHeight + 'px' }"
    ></div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { AppStoreTypes } from '../../store/modules/app';

export default {
  name: 'top-bar',
  data() {
    return {};
  },
  mounted() {},
  created() {},
  methods: {},
  computed: {
    ...mapGetters({
      user: AppStoreTypes.user.get,
    }),
    aktualisProjekt() {
      return this.user?.Projekt;
    },
    isMobile() {
      return this.$vuetify.breakpoint.smAndDown;
    },
  },
  watch: {},
  components: {},
  props: {
    placeholderHeight: {
      type: Number,
      default: 38,
    },
  },
};
</script>
